// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3449":"8f34f90d99b4ed78","4433":"1d483cd1ac89810c"}[chunkId] + ".css";
};